import './App.css';
import Nav from './components/Nav';
import Inputs from './components/Inputs';
function App() {
  return (
    <div className="App">
        <Nav />
        <Inputs />
    </div>
  );
}

export default App;
